import type { IFetchHeatmapDataProps } from '../api';

import { deepCopy } from '~/utils';

type WhereInput = IFetchHeatmapDataProps['whereInput'];

export const omitWhereInput = <K extends keyof WhereInput>(
  whereInput: WhereInput,
  keys?: K[],
): Omit<WhereInput, K> => {
  const result = deepCopy(whereInput);

  for (const key of keys ?? []) {
    delete result[key];
  }

  return result;
};
